import {useFirebaseAuthSimplified} from '@coolcolduk/ui-firebase-helper';
import {Auth} from 'firebase/auth';
import {doc, onSnapshot, type Unsubscribe} from 'firebase/firestore';
import {useEffect, useState} from 'react';
import {UserAccount} from '../__generated__/resolvers-types';
import {firebaseFirestore} from '../setup/firebase';

/**
 * Get and monitor user from Firestore (user/{uid}) and permissions from Firebase Auth custom claim craftySmileRole.
 * @returns object with user data and refetch function
 */
export default function useGetUser(auth: Auth): {
  user: undefined | null | UserAccount;
  refetch: () => Promise<void>;
  loading: boolean;
} {
  const [user, setUser] = useState<undefined | null | UserAccount>(undefined);
  const [loading, setLoading] = useState(true);
  const firebaseUser = useFirebaseAuthSimplified(auth);

  useEffect(() => {
    if (firebaseUser === undefined || firebaseUser === null) return;

    setLoading(true);
    const docRef = doc(firebaseFirestore, 'user', firebaseUser.uid);
    const unsub: Unsubscribe = onSnapshot(
      docRef,
      (snap) => {
        const data = snap.data() as UserAccount | undefined;
        setUser(data);
        setLoading(false);
      },
      () => {
        setUser(null);
        setLoading(false);
      },
    );
    return () => unsub();
  }, [firebaseUser]);

  const refetch = async (): Promise<void> => {
    // no longer required as it is now using subscription. kept dummy function for now
  };

  return {
    user: firebaseUser === null ? null : user,
    refetch,
    loading,
  };
}
